module.exports = __webpack_public_path__ + "img/edit_location_alt_outlined.6e26494f.svg";